import { useCallback } from "react";
import { useStore } from "react-redux";

import { SelectBeratung, Checkboxen, Einwilligungstext, RadioEinwilligung } from ".";

export const RechtlicheHinweise = (props) => {
  const {
    handleGeneralChange,
    showBeraterErrorMsg, beraterFeld, rechtlichesHinweis,
    showRechtlichesHinweisErrorMsg, updateHinweise
  } = props || {};
  const { configStorage } = useStore().getState();

  const updateCheckbox = useCallback((changed) => {
    const { index, value } = changed || {};
    if (isNaN(index) || typeof value === "undefined" || typeof updateHinweise !== "function") return;
    let checked = [...rechtlichesHinweis];
    checked[index] = !!value;
    let errors = [...showRechtlichesHinweisErrorMsg];
    errors[index] = !value;
    return updateHinweise({
      rechtlichesHinweis: checked,
      showRechtlichesHinweisErrorMsg: errors
    });
  }, [showRechtlichesHinweisErrorMsg, rechtlichesHinweis, updateHinweise]);

  const setBeratung = useCallback(e => {
    if (typeof handleGeneralChange === "function") {
      handleGeneralChange(e);
    }
  }, [handleGeneralChange]);

  return (
    <div className="row justify-content-end mb-three">
      <div className="col-12 col-md-10 col-lg-8 float-end">
        <SelectBeratung
          value={beraterFeld}
          display={configStorage.isMaShop()}
          onChange={setBeratung}
          error={showBeraterErrorMsg}
          aria-label="Beratung"
        />
        <RadioEinwilligung      
          value={rechtlichesHinweis ? rechtlichesHinweis[0] : null}
          onChange={newValue => {
            let checked = [...rechtlichesHinweis];
            checked[0] = newValue;
            let errors = [...showRechtlichesHinweisErrorMsg];
            errors[0] = !newValue;
            if (typeof updateHinweise === "function") {
              updateHinweise({
                rechtlichesHinweis: checked,
                showRechtlichesHinweisErrorMsg: errors
              });
            }
          }}
          error={showRechtlichesHinweisErrorMsg ? showRechtlichesHinweisErrorMsg[0] : false }
        />
        <Checkboxen
          textNummer="2"
          checked={rechtlichesHinweis}
          onChange={updateCheckbox}
          errors={showRechtlichesHinweisErrorMsg} />
        {!configStorage.isAnkaufShop()
          ? (
            <>
              <div className="form-indent">
                <Einwilligungstext textNummer="6" />
              </div>
              <Checkboxen
                textNummer="3"
                checked={rechtlichesHinweis}
                onChange={updateCheckbox}
                errors={showRechtlichesHinweisErrorMsg} />
            </>
          )
          : null}
        <Checkboxen
          textNummer="4"
          checked={rechtlichesHinweis}
          onChange={updateCheckbox}
          errors={showRechtlichesHinweisErrorMsg} />
        {configStorage.isKundenShop() ?
          <Checkboxen
            textNummer="5"
            checked={configStorage.isMaShop() ? !rechtlichesHinweis : rechtlichesHinweis}
            onChange={updateCheckbox}
            errors={showRechtlichesHinweisErrorMsg} />
          : null}
        <Einwilligungstext textNummer="7" />

        {!configStorage.isAnkaufShop() ?
          <Einwilligungstext textNummer="8" /> : null
        }
      </div>
    </div>
  );
};
